import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { InternalConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class InternalApiModule {
    public static forRoot(configurationFactory: () => InternalConfiguration): ModuleWithProviders<InternalApiModule> {
        return {
            ngModule: InternalApiModule,
            providers: [ { provide: InternalConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: InternalApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('InternalApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
